export const DPC_STAGES = ["LEAD", "ENQUIRY", "TEST DRIVE", "BOOKING", "RETAIL"];

export const pctTone = (p) => (p == null ? "text-muted-foreground" : p >= 100 ? "text-emerald-700" : p >= 85 ? "text-amber-600" : "text-red-600");
export const heatBg = (p) => (p == null ? "" : p >= 100 ? "bg-emerald-100 text-emerald-900" : p >= 85 ? "bg-amber-100 text-amber-900" : "bg-red-100 text-red-900");
export const fmtPct = (p) => (p == null ? "—" : `${p}%`);

export const PERIOD_OPTIONS = [
  { v: "today", l: "Today" },
  { v: "yesterday", l: "Yesterday" },
  { v: "W1", l: "Week 1" },
  { v: "W2", l: "Week 2" },
  { v: "W3", l: "Week 3" },
  { v: "W4", l: "Week 4" },
  { v: "mtd", l: "MTD" },
  { v: "month", l: "Full month" },
];

export const STATUS_META = {
  not_started: { label: "Not started", cls: "bg-secondary text-muted-foreground" },
  draft: { label: "Draft", cls: "bg-slate-200 text-slate-700" },
  submitted: { label: "Submitted", cls: "bg-blue-100 text-blue-800" },
  zonal_approved: { label: "Zonal approved", cls: "bg-indigo-100 text-indigo-800" },
  approved: { label: "Approved", cls: "bg-emerald-100 text-emerald-800" },
  returned: { label: "Returned", cls: "bg-red-100 text-red-700" },
};

export const monthOptions = (n = 13, ahead = 1) => {
  const out = [];
  const d = new Date();
  d.setDate(1);
  d.setMonth(d.getMonth() + ahead);
  for (let i = 0; i < n; i++) {
    out.push(`${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`);
    d.setMonth(d.getMonth() - 1);
  }
  return out;
};

export const monthLabel = (m) => {
  if (!m) return "";
  const names = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  return `${names[+m.slice(5, 7) - 1]} ${m.slice(0, 4)}`;
};

export const stageShort = (s) => (s === "TEST DRIVE" ? "T-DRIVE" : s);
